import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { API as API_BASE } from '../../lib/api';
import axios from 'axios';
import { Sparkles, CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading | success | error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('No verification token provided.');
            return;
        }

        axios.post(`${API_BASE}/auth/verify-email`, { token })
            .then(() => {
                setStatus('success');
                setMessage('Your email has been verified! You can now sign in.');
            })
            .catch(err => {
                setStatus('error');
                setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
            });
    }, [searchParams]);

    return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#FAFAF5' }}>
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-14 h-14 bg-stone-900 rounded-2xl shadow-lg mb-4">
                        <Sparkles className="w-7 h-7 text-white" />
                    </div>
                    <h1 className="text-3xl font-bold text-stone-900" style={{ fontFamily: 'Manrope, system-ui, sans-serif' }}>
                        Nurture <span className="text-stone-500">CRM</span>
                    </h1>
                </div>

                <div className="bg-white rounded-2xl border border-stone-200 shadow-sm p-8 text-center">
                    {status === 'loading' && (
                        <>
                            <Loader2 className="w-12 h-12 text-stone-400 animate-spin mx-auto mb-4" />
                            <h2 className="text-xl font-semibold text-stone-900 mb-2" style={{ fontFamily: 'Manrope, system-ui, sans-serif' }}>
                                Verifying your email...
                            </h2>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
                            <h2 className="text-xl font-semibold text-stone-900 mb-2" style={{ fontFamily: 'Manrope, system-ui, sans-serif' }}>
                                Email Verified
                            </h2>
                            <p className="text-stone-500 text-sm mb-6">{message}</p>
                            <Link
                                to="/login"
                                className="inline-block bg-stone-900 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-stone-800 transition-colors"
                            >
                                Sign In
                            </Link>
                        </>
                    )}

                    {status === 'error' && (
                        <>
                            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
                            <h2 className="text-xl font-semibold text-stone-900 mb-2" style={{ fontFamily: 'Manrope, system-ui, sans-serif' }}>
                                Verification Failed
                            </h2>
                            <p className="text-stone-500 text-sm mb-6">{message}</p>
                            <Link
                                to="/login"
                                className="inline-block bg-stone-900 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-stone-800 transition-colors"
                            >
                                Back to Login
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
